import React, { FC } from 'react';
import { LoadingSpinnerIcon } from 'common/icons';
import { IoMdSend } from 'react-icons/io';
import { SendButtonProps } from './send-button.types';

export const SendButton: FC<SendButtonProps> = ({ isLoading }) =>
  isLoading ? (
    <button className="bg-transparent" disabled type="button">
      <LoadingSpinnerIcon />
    </button>
  ) : (
    <button className="p-0.5 px-1 bg-primary flex justify-center items-center" type="submit">
      <IoMdSend color="white" size={28} />
    </button>
  );
